import React, { Component } from 'react'
import Link from 'gatsby-link'

class Header extends Component {
  state = {
    isPinned: false,
  }

  handleScroll = () => {
    if (window.scrollY > 400) {
      this.setState({
        isPinned: true,
      })
    } else {
      this.setState({
        isPinned: false,
      })
    }
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }
  render() {
    const { siteTitle, disablePinning } = this.props
    return (
      <header
        className={`header ${
          disablePinning || this.state.isPinned ? '' : 'alt'
        }`}
      >
        <h1>
          <Link to="/">{this.props.siteTitle}</Link>
        </h1>
        <nav className="nav">
          <ul>
            <li>
              <Link to="/news">NEWS</Link>
            </li>
            <li>
              <Link to="/team">TEAM</Link>
            </li>
            <li>
              <Link to="/buy" className="btn">
                {' '}
                BUY NOW
              </Link>
            </li>
          </ul>
        </nav>
      </header>
    )
  }
}
export default Header



// WEBPACK FOOTER //
// ./src/components/header.js